import { Box, Alert, AlertDescription } from '@vimeo/bokeh';

import { createDomName } from '../../../../utils/dom/identifying';
import { SlideUpDown } from '../../../slide_up_down';
import { INoticeProps } from './useNoticeProps';

export function ChatHistoryNotice({ content, showing, onClickAction }: INoticeProps) {
  return (
    <Box
      className={createDomName('chat-notice-slider-wrapper')}
      position={'absolute'}
      opacity={showing ? 1 : 0}
    >
      <SlideUpDown showing={showing}>
        <Box
          className={createDomName('chat-notice-wrapper')}
          cursor={'pointer'}
          backgroundColor={'surface'}
          onClick={onClickAction}
        >
          <Alert status={'info'}>
            <AlertDescription className={createDomName('chat-notice-text')}>
              {content}
            </AlertDescription>
          </Alert>
        </Box>
      </SlideUpDown>
    </Box>
  );
}
